module.exports = "/build/images/logo-animated.gif?d22e69687bde689ca0b63823fa522818";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/logo-animated.gif
// module id = 2281
// module chunks = 0